import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { getAnalytics, isSupported, logEvent } from "firebase/analytics";


export default function FirebaseAnalytics() {
    let location = useLocation();
    const [analytics, setAnalytics] = useState<any | null>(null);

    useEffect(() => {
        isSupported().then((supported) => {
            if (supported) {
                setAnalytics(getAnalytics());
            }
        });
    }, []);

    useEffect(() => {
        if (analytics) {
            const page_path = location.pathname + location.search;
            logEvent(analytics, "page_view", { page_path });
        }
    }, [location, analytics]);
    return null;
}
